import React, {useContext} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSquareXTwitter} from '@fortawesome/free-brands-svg-icons/faSquareXTwitter';
import {faFacebookSquare} from '@fortawesome/free-brands-svg-icons/faFacebookSquare';
import {faLinkedin} from '@fortawesome/free-brands-svg-icons/faLinkedin';
import {faWhatsappSquare} from '@fortawesome/free-brands-svg-icons/faWhatsappSquare';
import {faEnvelopeSquare} from '@fortawesome/pro-solid-svg-icons/faEnvelopeSquare';
import LangContext from "../providers/LangContext";

let pageUrl = document.location.href;

const Footer = (props) => {
    const {lang} = useContext(LangContext);
    return (
        <div style={{overflow: 'hidden'}} className={ 'container footer-container' + ( props.online_bidding != '0' ? ' bidding_spacing' : '' ) }>
            <div className="row">
                <hr className={"w-100 mt-0 mb-sm-3 footer-border-top" + ( props.theme === 'light' ? ' primary-border-color' : '' )} style={{'maxWidth': '95%'}}/>
                <div className="col-md-8 col-sm-6 d-none d-md-inline">
                    <div className="align-middle" dangerouslySetInnerHTML={{__html: props.footerHtmlText}}/>
                </div>
                <div className="col mb-3 text-center text-md-right">
                    <span className="align-middle">{lang.get('sites.share_on')}:</span>
                    <a href={"https://twitter.com/intent/tweet?text=" + pageUrl} target="_blank">
                        <FontAwesomeIcon className="mx-2 social-share-icons" icon={faSquareXTwitter}/>
                    </a>
                    <a href={"https://www.facebook.com/sharer/sharer.php?u=" + pageUrl} target="_blank">
                        <FontAwesomeIcon className="mx-2 social-share-icons" icon={faFacebookSquare}/>
                    </a>
                    <a href={"https://www.linkedin.com/shareArticle?mini=true&url="+ pageUrl} target="_blank">
                        <FontAwesomeIcon className="mx-2 social-share-icons" icon={faLinkedin}/>
                    </a>
                    <a href={"mailto:?subject=Share%20Object&body=" + pageUrl}>
                        <FontAwesomeIcon className="mx-2 social-share-icons" icon={faEnvelopeSquare}/>
                    </a>
                    <a href={"https://api.whatsapp.com/send?text=" + pageUrl} target="_blank" className="d-inline d-md-none">
                        <FontAwesomeIcon className="mx-2 social-share-icons" icon={faWhatsappSquare}/>
                    </a>
                </div>
            </div>
        </div>
    )

}

export default Footer;
